<template>
  <div class="container">
  <a-modal :title="title[hazardIndex]" :visible="hazardVisible" @ok="hazardPost" @cancel="closeHazard"
					width="40%">
					<a-form-model :model="hazardForm" ref="hazardFormRef" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
						<a-row>
							<a-col :span="24">
                                <a-form-model-item label="所属收费标准" prop="categoryId" v-if="hazardIndex == 0" :rules="{
							        required: true,
							        message: '请选择所属收费标准',
							        trigger: 'change',
							        }">
									<a-select allowClear placeholder="所属收费标准" v-model="hazardForm.categoryId"
										@change="changeHazards" disabled>
										<a-select-option :value="item.categoryId" v-for="(item, index) in factorsCateList"
											:key="index">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
						        </a-form-model-item>
                                <a-form-model-item label="所属收费标准" v-else>
									<span>{{hazardForm.category}}</span>
								</a-form-model-item>
							</a-col >
						</a-row>
						<a-row>
							<a-col :span="24">
								 <a-form-model-item label="所属子标准" prop="subcategoryId"  v-if="hazardIndex == 0" :rules="{
							  required: true,
							  message: '请选择所属子标准',
							  trigger: 'change',
							}">
									<a-select allowClear placeholder="所属子标准" v-model="hazardForm.subcategoryId" :disabled="!hazardForm.categoryId">
										<a-select-option :value="item.categoryId" v-for="(item, index) in subcategoryList"
											:key="index">
											{{ item.categoryName }}
										</a-select-option>
									</a-select>
						</a-form-model-item>
                         <a-form-model-item label="所属子标准" v-else>
									<span>{{hazardForm.subcategory}}</span>
								</a-form-model-item>
							</a-col>
						
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="名称" prop="factorName"  v-if="hazardIndex == 0" :rules="{
							  required: true,
							  message: '请输入名称',
							  trigger: 'change',
							}">
									<a-input v-model="hazardForm.factorName" allowClear placeholder="名称"></a-input>
								</a-form-model-item>
                                 <a-form-model-item label="名称" v-else>
									<span>{{hazardForm.factorName}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="检测标准" prop="standardInfo"  v-if="hazardIndex == 0" :rules="{
							  required: true,
							  message: '请输入检测标准',
							  trigger: 'change',
							}">
									<a-input v-model="hazardForm.standardInfo" allowClear placeholder="检测标准"></a-input>
								</a-form-model-item>
                                 <a-form-model-item label="检测标准" v-else>
									<span>{{hazardForm.standardInfo}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="限制范围" prop="limitRange"  v-if="hazardIndex == 0">
									<a-input v-model="hazardForm.limitRange" allowClear placeholder="限制范围"></a-input>
								</a-form-model-item>
                                 <a-form-model-item label="限制范围" v-else>
									<span>{{hazardForm.limitRange}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="单价(元)" prop="price"  v-if="hazardIndex == 0"  :rules="{
							  required: true,
							  message: '请输入单价(元)，只能为小数或者整数',
							  trigger: 'change',
							}">
									<a-input v-model="hazardForm.price" oninput="value=value.replace(/[^\d\.]/g,'')" allowClear placeholder="单价(元)"></a-input>
								</a-form-model-item>
                                 <a-form-model-item label="单价(元)" v-else>
									<span>{{hazardForm.price}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
  </div>
</template>

<script>
import {
  delete_factor,
  getFactorDetail,
  getUserListDetail,
  industryInfo,
  industryInfo_post,
  postInfo,
  addPostWithHarmFactor,
  editPostWithHarmFactor,
  industryInfo_details,
  industryInfo_put,
  postInfo_details,
  postInfo_put,
  baseFactor,
  getCategoryTree,
  subCategory,
  baseFactor_add,
  factor_details,
  editFactors_put,
  factor_list,
  deleteIndustryInfo,
  deleteFactor,
  getUserList,
} from '@/api/Industry'
export default {
  data() {
    return {
        title: [
            '编辑危害因素报价',
            '危害因素报价详情'
        ],
        hazardIndex: undefined,
      hazardVisible: false,
      hazardForm: {
        categoryId: undefined,
        subcategoryId: undefined,
        factorName: '',
        limitRange: '',
        price: '',
        standardInfo: ''

      }

    }
  },
  methods: {
  // 新增危害因素提交
  hazardPost() {
    if(this.hazardIndex == 0) {
          this.$refs.hazardFormRef.validate((valid) => {
        if (valid) {
          editFactors_put(this.hazardForm).then((res) => {
            if (res.code == 200) {
              this.$refs.hazardFormRef.resetFields()
              this.$message.success('编辑成功')
              this.hazardVisible = false
              this.$emit('rushHazard')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    } else {
      this.$refs.hazardFormRef.resetFields()
      this.hazardVisible = false

    }

  },
    //获取当前页面列表
    init(data) {
      this.$nextTick((res) => {
      this.hazardIndex = data.hazardIndex
      this.hazardVisible = true
      if(data.hazardIndex == 0) {
          getCategoryTree().then((res) => {
      if (res.code == 200) {
             this.factorsCateList = res.data 
             this.hazardForm  = JSON.parse(JSON.stringify(data.rowData))
             this.hazardForm.categoryId = 1002
             this.factorsCateList.forEach(item => {
            if (item.categoryId == 1002) {
            this.subcategoryList = item.childrenList
           }
   
        })
      } else {
        this.$message.error(res.msg)
      }
    })
      } else if(data.hazardIndex == 1) {
         this.hazardForm  = JSON.parse(JSON.stringify(data.rowData))
      }
    
  
      })
    
    //  if(this.hazardIndex == 1) {
    //    this.hazardForm = data.row
    //   }

    },
    closeHazard() {
         if(this.hazardIndex == 0) {
      this.$refs.hazardFormRef.resetFields()
         }
      this.hazardVisible = false
    },
    // changeHazards(e) {
    //   this.hazardForm.subcategoryId = undefined
    //   this.subcategoryList = []
    //   for (var i = 0; i < this.factorsCateList.length; i++) {
    //     if (this.factorsCateList[i].categoryId == e) {
    //       this.subcategoryList = this.factorsCateList[i].childrenList
    //     }
    //   }
    // },
}

}
</script>

<style>


</style>